import {
  fetchIpAddress,
  fetchSendUserTracker,
} from '@/src/utils/functions/fetchUserTracking';

import {
  IP_ADDRESS_DATAS,
  LOADING_IP_ADDRESS_DATAS,
  LOADING_USER_TRACKING_DATAS,
  USER_TRACKING_DATAS,
} from '../constants/user_tracking';

export function getIpAddressDatas(): (dispatch: any) => void {
  return (dispatch) => {
    dispatch(loadingIpAddressDatas());

    fetchIpAddress()
      .then((res: any) => {
        dispatch(ipAddressDatasFetched(res));
        return res;
      })
      .catch((res) => {
        dispatch(ipAddressDatasFetched(res));
      });
  };
}

function ipAddressDatasFetched(payload: any) {
  return {
    type: IP_ADDRESS_DATAS,
    payload,
  };
}

function loadingIpAddressDatas() {
  return { type: LOADING_IP_ADDRESS_DATAS };
}

export function sendUserTrackingDatas(payload: any, token: any): (dispatch: any) => void {
  return (dispatch) => {
    dispatch(loadingUserTrackingDatas());

    fetchSendUserTracker(payload, token)
      .then((res: any) => {
        dispatch(userTrackingDatasFetched(res));
        return res;
      })
      .catch((res) => {
        dispatch(userTrackingDatasFetched(res));
        dispatch(loadingUserTrackingDatas());
      });
  };
}

function userTrackingDatasFetched(payload: any) {
  return {
    type: USER_TRACKING_DATAS,
    payload,
  };
}

function loadingUserTrackingDatas() {
  return { type: LOADING_USER_TRACKING_DATAS };
}
